import { Trans } from '@lingui/react/macro';
import { type FC, memo } from 'react';
import { useCoin } from '@/shared/api';
import { Coin } from '@/shared/Coin';
import { cn } from '@/shared/react';

type CoinHeroProps = {
  slug?: string;
  type: 'price' | 'buy';
};

export const CoinHero: FC<CoinHeroProps> = memo(({ slug, type = 'price' }) => {
  const coin = useCoin(slug);
  return (
    <section className={cn('px-3')}>
      <div className="flex flex-col gap-8 desktop:flex-row desktop:items-end">
        <div className="w-full space-y-4">
          <div className="flex items-center gap-3 flex-wrap">
            <Coin coin={coin.data} size={8} variant="icon" />
            <h1 className="text-2xl desktop:text-2xl font-medium text-content-primary">
              {type === 'buy' ? (
                <Trans>
                  Buy <Coin variant="name" size={10} coin={coin.data} /> (
                  {coin.data?.symbol || slug}) with Iraqi Dinar
                </Trans>
              ) : type === 'price' ? (
                <Trans>
                  <Coin variant="name" size={10} coin={coin.data} /> (
                  {coin.data?.symbol || slug}) Price in Iraqi Dinar
                </Trans>
              ) : null}
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
});
